<template>
  <div class="user-assets-container">
    <div class="balance-title">
      {{ $t('exchange.token_balance') }}
    </div>
    <div class="tokens-container">
      <div
        v-if="tokens.length"
        class="columns is-mobile is-multiline"
      >
        <div
          v-for="(token, index) in tokens"
          :key="index"
          :class="[
            'column is-one-third-tablet is-half-mobile',
            {
              'height-0': !isExpand && index >= defaultCollapseNumber,
              'height-auto': isExpand && index >= defaultCollapseNumber
            }
          ]"
        >
          <TokenItem
            :img="token.code"
            :code="token.code"
            :name="token.name"
            :balance="token.balance"
            data-test="user-tokens--token-item"
          />
        </div>
      </div>
      <div
        v-else
        class="columns is-mobile is-multiline"
      >
        <div
          v-for="(index) in 6"
          :key="index"
          class="column is-one-third-tablet is-half-mobile"
        >
          <div class="item-box-skt">
            <div class="token-logo-skt">
              <b-skeleton
                circle
                width="30px"
                height="30px"
              />
            </div>
            <div class="token-name-skt">
              <b-skeleton :count="3"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line"/>
    <div
      class="expand-box"
      @click="isExpand = !isExpand"
    >
      <span>
        {{ isExpand ? $t('exchange.see_less') : $t('exchange.see_more') }}
      </span>
      <a>
        <img
          :class="{'rotate-180deg': isExpand}"
          src="/static/svg/arrow-drop-down.svg"
        >
      </a>
    </div>
  </div>
</template>

<script>
import TokenItem from '@/components/TokenItem'
/**
 * UserTokens Component
 */
export default {
  name: 'UserTokens',
  components: {
    TokenItem
  },
  props: {
    tokens: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isExpand: false,
      defaultCollapseNumber: 9
    }
  },
  created () {
    if (window.innerWidth <= 768) {
      this.defaultCollapseNumber = 6
    }
  }
}
</script>

<style scoped>
.user-assets-container {
  float: left;
  width: 100%;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.tokens-container {
  float: left;
  width: 100%;
  padding: 0 20px;
  margin-bottom: 20px;
  min-height: 282px;
}
.balance-title {
  float: left;
  width: 100%;
  font-size: 18px;
  color: #2193ff;
  margin-bottom: 10px;
  padding: 20px 20px 0 20px;
}
.line {
  float: left;
  width: 100%;
  height: 2px;
  border: solid 1px #cecece;
  margin-top: 20px;
}
.expand-box {
  float: left;
  width: 100%;
  padding: 16px 20px;
  color: #0096ed;
  cursor: pointer;
}
.expand-box a {
  float: right;
}
.expand-box span {
  float: left;
}
.height-0 {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.5s !important;
  padding: 0px;
}
.height-auto {
  max-height: 110px;
  overflow: hidden;
  transition: max-height 0.5s !important;
}
.rotate-180deg {
  transform: rotate(180deg);
}
.item-box-skt {
  float: left;
  width: 100%;
  margin-top: 15px;
}
.token-logo-skt {
  float: left;
  width: 30px;
}
.token-name-skt {
  float: left;
  width: 60%;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/features/UserAssets/components/UserTokens.vue